"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extraMenuItems = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _topicService = require("@insided/destination/modules/Content/TopicList/services/topicService");

var extraMenuItems = function extraMenuItems(params) {
  var showMarkAsSpamModal = params.showMarkAsSpamModal,
      showTrashModal = params.showTrashModal,
      contentType = params.contentType;
  var showMarkAsSpam = contentType !== 'article' && contentType !== 'productUpdate';
  var menuItems = [{
    title: params.isSticky ? 'frontend_moderation.unmark_as_sticky' : 'frontend_moderation.mark_as_sticky',
    type: 'normal',
    onClick: function () {
      var _onClick = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _topicService.onChangeSticky)(e, params.privateId, params.isSticky, contentType, params.onShowAlert);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onClick(_x) {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    title: params.isClosed ? 'frontend_moderation.reopen_topic_for_replies' : 'frontend_moderation.close_topic_for_replies',
    type: 'normal',
    onClick: function () {
      var _onClick2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(e) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _topicService.onChangeCloseTopicForReplies)(e, params.privateId, params.isClosed, contentType, params.onShowAlert);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onClick(_x2) {
        return _onClick2.apply(this, arguments);
      }

      return onClick;
    }()
  }];

  if (showMarkAsSpam) {
    menuItems.push({
      title: 'frontend_moderation.mark_as_spam',
      type: 'alert',
      onClick: function onClick(e) {
        return (0, _topicService.onMarkAsSpam)(e, showMarkAsSpamModal);
      }
    });
  }

  menuItems.push({
    title: 'frontend_moderation.trash',
    type: 'alert',
    onClick: function onClick(e) {
      return (0, _topicService.onTrash)(e, showTrashModal);
    }
  });
  return menuItems;
};

exports.extraMenuItems = extraMenuItems;